import { VideoAnnotation } from 'api/schema'

export const isOverdue = (annotation: VideoAnnotation) => {
  return annotation.is_expired
}
